// Enterprise Smart Sign-Up experience launched via AmexSession.loadExperience.
// Shared by the Register welcome page and the enrollment conflict flow.
export const SIGN_UP_EXPERIENCE = Object.freeze({
  experienceId: '8227f0ee-520d-4daf-8129-f1f01443074e',
  // url: 'https://identity-12-dev.americanexpress.com',
});
